// Axios Conf
import axios from "axios";

var isIE = /*@cc_on!@*/false || !!document.documentMode; // Internet Explorer 6-11 kullananlara mesaj
if(isIE){
  alert("Masraf modülünü daha etkili kullanmabilmek için Lütfen Tarayıcınızı değiştirin. (Google Chrome,Firefox vb önerilir)")
}
console.log(process.env)


if(process.env.REACT_APP_ENV == "production"){
  axios.defaults.baseURL = 'https://masraf.dakika.com.tr';
}else if(process.env.REACT_APP_ENV == "test"){
  axios.defaults.baseURL = 'https://testmasraf.dakika.com.tr';
}else if(process.env.REACT_APP_ENV == "dev"){
  axios.defaults.baseURL = 'https://dev-glasshouse-masraf.dakika.com.tr';
}else{
  axios.defaults.baseURL = 'http://localhost:3004';
}

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// Date conf
Date.prototype.monthNames = [
  "Ocak",
  "Şubat",
  "Mart",
  "Nisan",
  "Mayıs",
  "Haziran",
  "Temmuz",
  "Ağustos",
  "Eylül",
  "Ekim",
  "Kasım",
  "Aralık"
];
Date.prototype.getFullMonth = () => {
  return Date.prototype.monthNames[new Date().getMonth()];
};

// Money Units
window.Money = function (moneyUnit){
  this.moneyUnits = {
    "TL":"₺",
    "DOLAR":"$",
    "EURO":"€",
    "STERLIN":"£",
    "DKK":"DKK",
    "İSVEÇ KRONU (SEK)": "kr",
    "JAPON YENİ": "¥",
    "Diğer":"Diğer",
    "AUD"	: "$",
    "CHF"	: "CHF",
    "CAD"	: "$",
    "KWD"	: "د.ك",
    "NOK"	: "kr",
    "SAR"	: "﷼",
    "BGN"	: "лв",
    "RON"	: "lei",
    "RUB"	: "руб",
    "IRR"	: "﷼",
    "CNY"	: "¥",
    "PKR"	: "PKR",
    "QAR"	: "﷼",
    "KRW"	: "₩",
    "AZN"	: "ман",
    "AED"	: "د.إ",
  }
  this.moneyCodes= {
    "DOLAR":"USD",
    "EURO":"EUR",
    "STERLIN":"GBP",
    "DKK":"DKK",
    "İSVEÇ KRONU (SEK)": "SEK",
    "JAPON YENİ": "JPY",
    "AUD"	: "AUD",
    "CHF"	: "CHF",
    "CAD"	: "CAD",
    "KWD"	: "KWD",
    "NOK"	: "NOK",
    "SAR"	: "SAR",
    "BGN"	: "BGN",
    "RON"	: "RON",
    "RUB"	: "RUB",
    "IRR"	: "IRR",
    "CNY"	: "CNY",
    "PKR"	: "PKR",
    "QAR"	: "QAR",
    "KRW"	: "KRW",
    "AZN"	: "AZN",
    "AED"	: "AED",
}
this.moneyI18nCodes = {
  "TL":"tl",
  "DOLAR":"dollar",
  "EURO":"euro",
  "STERLIN":"sterling",
  "DKK":"dkk",
  "İSVEÇ KRONU (SEK)": "sek",
  "JAPON YENİ": "jpy",
  "Diğer":"other",
  "AUD"	: "AUD",
  "CHF"	: "CHF",
  "CAD"	: "CAD",
  "KWD"	: "KWD",
  "NOK"	: "NOK",
  "SAR"	: "SAR",
  "BGN"	: "BGN",
  "RON"	: "RON",
  "RUB"	: "RUB",
  "IRR"	: "IRR",
  "CNY"	: "CNY",
  "PKR"	: "PKR",
  "QAR"	: "QAR",
  "KRW"	: "KRW",
  "AZN"	: "AZN",
  "AED"	: "AED",
}
  
  this.getAllMoney = () => {
    return this.moneyUnits;
  }
  this.getAllMoneyI18nCodes = () => {
    return this.moneyI18nCodes;
  }
  this.getMoneySymbol = () => {
    return this.moneyUnits[moneyUnit];
  }
  this.getMoneyCode = () => {
     return this.moneyCodes[moneyUnit];
  }
};

window.loop = function(start,end,cb){
  var row = [];
  if(cb)
    for(var i=start;i<=end;i++)
        row.push(cb(i))
  else
    for(var i=start;i<=end;i++)
        row.push(i)
  return row;
}

// Masraf Images Path
window.costImages = {
  url:"https://s3.eu-central-1.amazonaws.com/masraf-images/invoice-images/"
}

window.costStartingYear = 2017;
